import createStore from "astrid-helpers/src/createStore";
export const [getScope, setScope, useScope, onScope] = createStore({
  end: 0,
  size: 0,
  start: 0,
  offset: 0
}, scope => ({
  ...scope,
  length: scope.end - scope.start
}));
//# sourceMappingURL=scope.js.map